<template>
	<div>
		<NuxtLayout :name="routeLayouts[activeRoute] as LayoutKey">
			<CustomToast />
			<NuxtPage />
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
	import CustomToast from "~/components/CustomToast.vue";
	import type {
		LayoutKey
	} from "nuxt/app";
	import type {
		Routes
	} from "@/types/utility";

	const { activeRoute } = utilityStores();
	const routeLayouts: Routes = {
		"/": "beige-background",
		"/home": "beige-background",
		"/dress-code": "beige-background",
		"/gallery": "beige-background",
		"/wedding-party": "beige-background",
		"/q-and-a": "beige-background",
		"/travel": "beige-background",
		"/things-to-do": "beige-background",
		"/registry": "beige-background",
		"/password": "beige-background",
		"/rsvp": "beige-background"
	};
</script>

<style scoped>

</style>